<template>
  <v-container id="settings" fluid class="px-0 py-0" v-if="isAdministrator">
    <v-tabs v-model="tab" color="primary" height="64">
      <v-tab><v-icon left>mdi-cog</v-icon>Impostazioni</v-tab>
      <v-tab><v-icon left>mdi-office-building</v-icon>La mia Scuola</v-tab>
      <v-tab><v-icon left>mdi-folder-cog</v-icon>Aree e Attività</v-tab>
      <v-tab><v-icon left>mdi-account-group</v-icon>Utenti</v-tab>
    <!-- </v-tabs> -->
    <!-- <v-tabs-items v-model="tab"> -->
      <v-tab-item>
        <settings-view ref="refSettingsView"></settings-view>
      </v-tab-item>
      <v-tab-item>
        <school-view ref="refSchoolView"></school-view>
      </v-tab-item>
      <v-tab-item>
        <area-view ref="refAreaView"></area-view>
      </v-tab-item>
      <v-tab-item>
        <user-view ref="refUserView"></user-view>
      </v-tab-item>
    <!-- </v-tabs-items> -->
    </v-tabs>
  </v-container>
</template>

<script>
import SettingsViewVue from '../components/settings/SettingsView.vue';
import SchoolViewVue from '../components/settings/SchoolView.vue';
import AreaViewVue from '../components/settings/AreaView.vue';
import UserViewVue from '../components/settings/UserView.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    'settings-view': SettingsViewVue, // gestione delle impostazioni.
    'school-view': SchoolViewVue, // visualizzazione dati scuola.
    'area-view': AreaViewVue, // gestione delle aree e delle attività.
    'user-view': UserViewVue, // gestione degli utenti.
  },

  data: ()=> ({
    tab: null, 
  }),

  computed: {
    ...mapGetters('oidcStore', [ 'oidcIsAuthenticated', 'oidcUser' ]),
    ...mapGetters('argoStore', [ 'isAdministrator' ]),
  }
}
</script>